import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import Pagination from "react-bootstrap/Pagination";

import { Link } from "react-router-dom";

import './Resume.css'
import { awardData } from "./Award_Data";

function Resume_Award() {
  const [selectedType, setSelectedType] = useState("All"); // Default: Show all data
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const handleBadgeClick = (type) => {
    // Reset currentPage to 1 when a badge is clicked
    setCurrentPage(1);
    setSelectedType(type);
  };

  const uniqueTypes = [...new Set(awardData.map((data) => data.type))]; // Remove duplicate types

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = awardData
    .filter((data) => selectedType === "All" || data.type === selectedType)
    .slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(
    awardData
      .filter((data) => selectedType === "All" || data.type === selectedType)
      .length / itemsPerPage
  );

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Reset currentPage to 1 when selectedType changes
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedType]);

  return (
    <>
      <Card className={"resume-card"}>
        <h1 className={"resume-card-title"}> Award </h1>
        <p className={"resume-card-subtitle"}> ※ For development / data analysis awards, clicking will redirect to the corresponding project page. </p>
        <div>
          <Badge
            className={"resume-badges2 " + (selectedType === "All" ? "bg-active" : "bg-white")}
            onClick={() => handleBadgeClick("All")}
          >
            <div style={{ fontWeight: "lighter" }}>All</div>
          </Badge>
          {uniqueTypes.map((type, index) => (
            <Badge
              key={index}
              className={"resume-badges2 " + (selectedType === type ? "bg-active" : "bg-white")}
              onClick={() => handleBadgeClick(type)}
            >
              <div style={{ fontWeight: "lighter" }}>{type}</div>
            </Badge>
          ))}
        </div>

        <div className="resume-card-contents">
          <div className="row">
            {currentItems.map((data, index) => (
              <div key={index} className="col-md-4 mb-3 award_list">

                {data.type === "Development" || data.type === "Data Analysis" ? (
                  <Link to={`/project-detail-eng/${data.projectId}`} style={{ textDecoration: "none", color: "black" }}>
                    <Card className="award-card">
                      <Card.Body>
                        <Card.Title className="award-title">{data['Award Name']}</Card.Title>
                        <hr></hr>
                        <Card.Text className="award-contents1">{data['Award Details']}</Card.Text>
                        <Card.Text className="award-contents2">{data['Organization']}</Card.Text>
                        <Card.Text className="award-contents3">{data['Date of Award']}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Link>
                ) : (
                  <Card className="award-card">
                    <Card.Body>
                      <Card.Title className="award-title">{data['Award Name']}</Card.Title>
                      <hr></hr>
                      <Card.Text className="award-contents1">{data['Award Details']}</Card.Text>
                      <Card.Text className="award-contents2">{data['Organization']}</Card.Text>
                      <Card.Text className="award-contents3">{data['Date of Award']}</Card.Text>
                    </Card.Body>
                  </Card>
                )}

              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-center mt-3">
            <Pagination>
              {Array.from({ length: totalPages }).map((_, index) => (
                <Pagination.Item
                  key={index}
                  active={index + 1 === currentPage}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}
            </Pagination>
          </div>
        </div>
      </Card>
    </>
  );
}

export default Resume_Award;
